import { Controller } from "@hotwired/stimulus"

export class RoleApplicationsController extends Controller {
  static targets = ["menu"]

  connect() {
    this.menu = this.menuTarget
    this.portalMenu = this.portalMenu.bind(this)
    this.restoreMenu = this.restoreMenu.bind(this)
    this.element.addEventListener("show.coreui.dropdown", this.portalMenu)
    this.element.addEventListener("hidden.coreui.dropdown", this.restoreMenu)
  }

  disconnect() {
    this.element.removeEventListener("show.coreui.dropdown", this.portalMenu)
    this.element.removeEventListener("hidden.coreui.dropdown", this.restoreMenu)
    this.restoreMenu()
  }

  portalMenu() {
    document.body.append(this.menu)
  }

  restoreMenu() {
    this.element.append(this.menu)
  }
}
